module.exports = __webpack_public_path__ + "img/role02.56e3ce0e.png";